import { Link } from 'react-router-dom';

const productLinks = [
  { label: 'Features', path: '/features' },
  { label: 'How It Works', path: '/how-it-works' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Security', path: '/security' }
];

const companyLinks = [
  { label: 'Contact', path: '/contact' }
];

const legalLinks = [
  { label: 'Privacy Policy', path: '/privacy' },
  { label: 'Terms of Service', path: '/terms' }
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__grid">
        <div className="footer__brand">
          <div className="footer__mark">TA</div>
          <div className="footer__brandCopy">
            <span className="footer__title">textadapt</span>
            <p className="footer__subtitle">
              LLM-first document intelligence engineered for finance operations.
            </p>
          </div>
        </div>

        <div className="footer__column">
          <span className="footer__heading">Product</span>
          <ul className="footer__links">
            {productLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__column">
          <span className="footer__heading">Company</span>
          <ul className="footer__links">
            {companyLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__column">
          <span className="footer__heading">Connect</span>
          <a className="footer__contact" href="mailto:sales@textadapt.com">
            sales@textadapt.com
          </a>
          <a className="footer__contact" href="https://platform.textadapt.com">
            Platform Status
          </a>
        </div>
      </div>

      <div className="footer__bottom">
        <span>© {currentYear} textadapt. All rights reserved.</span>
        <div className="footer__meta">
          {legalLinks.map((link, index) => (
            <span key={link.path}>
              <Link to={link.path}>{link.label}</Link>
              {index < legalLinks.length - 1 && ' • '}
            </span>
          ))}
        </div>
      </div>
    </footer>
  );
};
